import * as Yup from 'yup'

export const validationSchema = Yup.object({
    name: Yup.string().required('Name field is required'),
    reportingLevel: Yup.string().required('Reporting Level field is required'),
    xbrlReportingLevel: Yup.string().required('Xbrl Reporting Level field is required'),
    xbrlIdentifier: Yup.string().required('Xbrl Identifier field is required')
})